import { useCallback } from 'react';
import {
  IFilterAllData,
  ListOfKeysFilterAllData,
} from 'src/typings/filter';
import { View2dType } from 'src/typings/view-2d';
import { useSelector } from 'react-redux';
import { getView2dSelectedTypes } from 'src/store/view-2d/selectors';
import { useBuildType } from 'src/hooks';
import { useCrosstableStatusToggle } from 'src/components/CrosstableContainer/hooks';
import { View2dTypeMap } from 'src/components/CrosstableContent/components/Section/types';

export const useFillFloorsItem = () => {
  const view2dSelectedType = useSelector(getView2dSelectedTypes);
  const { isCrossTable } = useBuildType();
  const { disabledStatusesList, isStatusDisabledByStatusName } = useCrosstableStatusToggle();
  const getFillFloorsItemText = useCallback((fillFloorsItem: IFilterAllData): string => {
    const map: { [key in View2dType]?: string } = {
      [View2dType.area]: fillFloorsItem[ListOfKeysFilterAllData.placementTotalArea] || '',
      [View2dType.rooms]: fillFloorsItem[ListOfKeysFilterAllData.placementRooms] || '',
      [View2dType.numeration]: fillFloorsItem[ListOfKeysFilterAllData.placementNumeration] || '',
      [View2dType.price]: fillFloorsItem[ListOfKeysFilterAllData.placementTotalPrice] || '',
      [View2dType.priceAlternative]: fillFloorsItem[ListOfKeysFilterAllData.placementTotalPriceAlternative] || '',
      [View2dType.pricePM]: fillFloorsItem[ListOfKeysFilterAllData.placementPricePerSqM] || '',
      [View2dType.pricePMAlternative]: fillFloorsItem[ListOfKeysFilterAllData.placementPricePerSqMAlternative] || '',
      [View2dType.row0]: fillFloorsItem[ListOfKeysFilterAllData.row0] || '',
      [View2dType.row1]: fillFloorsItem[ListOfKeysFilterAllData.row1] || '',
      [View2dType.row2]: fillFloorsItem[ListOfKeysFilterAllData.row2] || '',
      [View2dType.row3]: fillFloorsItem[ListOfKeysFilterAllData.row3] || '',
      [View2dType.row4]: fillFloorsItem[ListOfKeysFilterAllData.row4] || '',
      [View2dType.row5]: fillFloorsItem[ListOfKeysFilterAllData.row5] || '',
      [View2dType.row6]: fillFloorsItem[ListOfKeysFilterAllData.row6] || '',
      [View2dType.row7]: fillFloorsItem[ListOfKeysFilterAllData.row7] || '',
      [View2dType.row8]: fillFloorsItem[ListOfKeysFilterAllData.row8] || '',
      [View2dType.row9]: fillFloorsItem[ListOfKeysFilterAllData.row9] || '',
    };
    let floorItemText: string = map[view2dSelectedType] || '';
    const config = View2dTypeMap[view2dSelectedType];
    if (config?.type === 'number') {
      if ('isPrice' in config && config.isPrice) {
        if ((!isCrossTable && fillFloorsItem[ListOfKeysFilterAllData.placementStatusShowInModule] === 'hide') || isStatusDisabledByStatusName(fillFloorsItem[ListOfKeysFilterAllData.placementStatus])) {
          return '';
        }
        const price = Number(Number(floorItemText).toFixed(0));
        floorItemText = price ? `${price}` : '';
      }
      if ('needToBeRounded' in config && config.needToBeRounded) {
        floorItemText = (Math.trunc(Number(floorItemText)).toString().length >= 3
          ? Number(floorItemText).toFixed(0)
          : floorItemText);
      }
      if ('needToBeShort' in config && config.needToBeShort && floorItemText.length > 4) {
        const rounded = Math.round(Number(floorItemText) / 1000);
        floorItemText = rounded ? `${rounded}k` : '';
      }
    }
    return floorItemText;
  }, [view2dSelectedType, isCrossTable, disabledStatusesList]);

  return {
    getFillFloorsItemText,
  };
};
